import { CallGroupTypes } from '@frontend/api-call-group';
import { ForwardingNumberTypes } from '@frontend/api-forwarding-number';
import { useTranslation } from '@frontend/i18n';
import { SettingsTenantLocation } from '@frontend/phone-config';
import { Button, useMultiStepModalControl } from '@frontend/design-system';
import { trackingId } from '../../tracking';
import { CreateCallGroupModal } from './create-call-group-modal';

export const CreateCallGroupButton = ({
  tenantLocation,
  devices,
  callForwardingNumbers,
}: {
  tenantLocation: SettingsTenantLocation;
  devices: CallGroupTypes.SipProfileType[];
  callForwardingNumbers: ForwardingNumberTypes.FwdNumberModel[];
}) => {
  const { triggerProps, ...createCallGroupModalProps } = useMultiStepModalControl(
    { onComplete: () => {}, onCancel: () => {}, showCancelAction: true },
    { onClose: () => {} }
  );

  const handleOpenCreateCallGroup = () => {
    createCallGroupModalProps.goToStep({ orIndex: 0 });
    triggerProps.onClick();
  };

  const { t } = useTranslation('phone');

  return (
    <>
      <Button
        size='large'
        {...triggerProps}
        css={{ width: 'fit-content' }}
        trackingId={trackingId({ context: 'setting', feature: 'call-groups', details: 'create-createModal' })}
        onClick={handleOpenCreateCallGroup}
      >
        {t('Create Call Group')}
      </Button>
      <CreateCallGroupModal
        tenantLocation={tenantLocation}
        devices={devices}
        callForwardingNumbers={callForwardingNumbers}
        modalProps={createCallGroupModalProps}
      />
    </>
  );
};
